export default __webpack_public_path__ + "static/media/northern_lights3.4e7ef61e.jpg";